// extracted by mini-css-extract-plugin
module.exports = {"Accordion":"styles_Accordion__Wpybx","accordionTitle":"styles_accordionTitle__WAKs4"};